/**
 * Semantic tone pairs.
 *
 * Each entry is a complete (background, foreground) couple, written out in full
 * because Tailwind only sees classes that appear literally in source. Badges
 * take a tone name rather than loose colours, so a background can never be
 * paired with a foreground it was not contrast-checked against.
 */
export const TONES = {
  ok: 'bg-ok-bg text-ok-fg',
  warn: 'bg-warn-bg text-warn-fg',
  err: 'bg-err-bg text-err-fg',
  info: 'bg-info-bg text-info-fg',
  mute: 'bg-mute-bg text-mute-fg',
  accent: 'bg-primary/10 text-primary',
  purple: 'bg-purple-bg text-purple-fg',
} as const;

export type ToneName = keyof typeof TONES;

/** Dot colours matching each tone's foreground, for status indicators. */
export const TONE_DOTS: Readonly<Record<ToneName, string>> = {
  ok: 'bg-ok-fg',
  warn: 'bg-warn-fg',
  err: 'bg-err-fg',
  info: 'bg-info-fg',
  mute: 'bg-mute-fg',
  accent: 'bg-primary',
  purple: 'bg-purple-fg',
};
